<template>
  <div class="system-pageAddD" id="app" style="overflow-y: scroll;">
    <div v-if="isLoading" class="back-loading">数据加载中...</div>
    <mt-header title="物品采购申请单">
      <mt-button icon="back" slot="left" @click.native="goBack">返回</mt-button>
    </mt-header>
    <div style="width: 21rem; ">
      <div class="userinfoAdd">
        <div style="border-bottom: 1px solid #e0d8d8">
          <van-field v-model="userName" label="申请人" readonly/>
        </div>
        <div class="dynamic-table">
          <div v-for="(item, index) in dataList" :key="index" class="table-row">
            <van-field v-model="item.itemName" placeholder="物品名称"/>
            <van-field v-model="item.itemModel" placeholder="规格型号"/>
            <van-field v-model="item.number" type="number" placeholder="数量"/>
          </div>
          <van-button class="addsub" size="small" @click="addRow">添加行</van-button>
        </div>
        <van-field
            label="备注"
            class="owntext"
            v-model="processDescribe"
            rows="2"
            autosize
            type="textarea"
            placeholder=""
            show-word-limit
        />
        <van-field name="uploader" label="附件">
          <template #input>
            <div  class="btn btn-default"style="position: relative; overflow: hidden;
              margin-top: 6px;">
              <i class="glyphicon glyphicon-open"></i> 上传附件
              <input type="file" name="filePath" style="opacity: 0; position: absolute;
               top: 12px; right: 0; " class='inpu' @change="fileListChange">
            </div>
          </template>
        </van-field>
        <van-field name="uploader" label="">
          <template #input>
            <div v-if="fileList.length!=0" style="display: flex; flex-direction: column;">
              <div
                  v-for="(item, idx) in fileList"
                  :key="idx"
                  style="display: flex; align-items: center; margin-bottom: 5px;">
                <span>{{ item.attachmentName }}</span><div class="delete-btn" @click.prevent="fileListdel(item)">x</div>
              </div>
            </div>
          </template>
        </van-field>
        <van-field name="uploader"
                   label="审核人员"
                   v-if="roleId!=12">
          <template #input>
            <div style="color: black;">{{nameuser}}</div>
          </template>
        </van-field>
        <van-field name="uploader"
                   label="主要领导审批"
                   v-if="roleId==12">
          <template #input>
            <div @click.prevent="isZyVisible=true" style="color: black;">
              {{isZyName}}
              <i class="mintui mintui-field-error"></i>
            </div>
          </template>
        </van-field>
        <div v-if="roleId==12" style="display: flex; gap: 8px;">
          <div v-if="iszyld==0" class="sub" @click.prevent="liuzhuanSubmit">审核并流转</div>
          <div v-else class="sub" @click.prevent="jieanSubmit">审核并结案</div>
          <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
        </div>
        <div  v-else style="display: flex; gap: 8px;">
          <div  class="sub" @click.prevent="handelSubmit">提交</div>
          <div  class="sub" @click.prevent="caogaoSubmit">保存草稿</div>
        </div>
      </div>
      <!-- 是否需要主要领导审批选择 -->
      <mt-popup
          style="width: 100%"
          v-model="isZyVisible"
          position="bottom"
          popup-transition="popup-fade"
      >
        <mt-header>
          <mt-button @click.native="isZyVisible = false" slot="left"
          >关闭</mt-button
          >
          <mt-button @click.native="selectIsZyPicker" slot="right"
          >确认</mt-button
          >
        </mt-header>
        <mt-picker
            :slots="isZyList"
            ref="isZyList"
            valueKey="name"
        ></mt-picker>
      </mt-popup>
    </div>
  </div>
</template>

<script>
import {Toast} from "mint-ui";
import {getLocalData} from "@/utils/sessionData";
import axios from "axios";
import request from "@/utils/keyCloakRequest";

export default {
  data() {
    return {
      isZyName: "是",
      roleId: "",
      dataList: [
        // 初始时可以有一行作为示例，也可以为空数组让用户自己添加
        { itemName: '', itemModel: '', number: '' }
      ],
      fileList: [],
      fileIds: [],
      processDescribe: "",
      userName: "",
      userId:"",
      isLoading: false,
      isZyVisible: false,
      isZyList:[
        {
          values: [
            {
              code: "0",
              name: "是"
            },
            {
              code: "1",
              name: "否"
            }
          ],
          className: "slot1"
        }
      ],
      nameuser: null,//审核人姓名
      userInfo:{},
      iszyld:0,
      route:'',
      item:{},
      processId:'',
    };
  },
  computed: {
  },
  async created() {
    this.userInfo = JSON.parse(getLocalData("userInfo"))
    this.userName = this.userInfo.userName
    this.userId = this.userInfo.userId
    if(this.userId==this.userInfo.dept.deptmanager){
      await request({
        url: "getOfficeName?userId="+this.userId,
        method: "get"
      }).then( response => {
        this.nameuser = response
      })
    }else {
      await request({
        url: "getManagerName?userId="+this.userId,
        method: "get"
      }).then( response => {
        this.nameuser = response
      })
    }
    request({
      url: "appFindRoleId?userId="+this.userId,
      method: "get"
    }).then(  response => {
      this.roleId = response
    })
    this.processId = this.$route.query.item==undefined?'':this.$route.query.item.processId
    if(this.processId){
      axios({
        url: process.env.VUE_APP_SSO_URL+"apppurchasedDetail?processId="+this.processId,
        method: "get",
      }).then(response => {
        this.item = response.data
        this.dataList = this.item.pitems
        this.iszyld = this.item.iszyld
        this.isZyName = this.iszyld==0?'是':'否'
        console.log(this.item)
        this.processDescribe = this.item.processDescribe	//流程申请原因内容

        if(this.item.proFileid!=""){
          this.fileIds =   this.item.proFileid.split(",")
          request({
            url: "appDocumentFile?fileIds="+this.item.proFileid,
            method: "get"
          }).then(  response => {
            response.forEach(file => {
              this.fileList.push(file)
            });
          })
        }
      })
    }
    this.route =  this.$route.query.route
  },
  watch: {
  },
  methods: {
    selectIsZyPicker(){
      this.iszyld = this.$refs.isZyList.getValues()[0].code;
      this.isZyName =  this.$refs.isZyList.getValues()[0].name;
      this.isZyVisible = false;
    },
    addRow() {
      // 添加新行，初始数量为1或其他默认值
      this.dataList.push({ itemName: '', itemModel: '', number: '' });
    },
    removeRow(index) {
      // 删除指定行
      this.dataList.splice(index, 1);
    },
    fileListChange(event){
      const file = event.target.files[0]
      axios({
        url: process.env.VUE_APP_SSO_URL+"appSavePfile",
        method: "POST",
        headers: {
          'Content-Type': 'multipart/form-data'
        },
        data: {file:file,userId:this.userId}
      }).then(  response => {
        this.fileList.push(response.data)
        this.fileIds.push(response.data.attachmentId)
      })
    },
    fileListdel(attachment){
      this.fileList.splice(this.fileList.indexOf(attachment),1)
      this.fileIds.splice(this.fileIds.indexOf(attachment.attachmentId),1)
    },
    liuzhuanSubmit(){
      let params = {
        processId : this.processId,
        userId : this.userId,			//流程申请人
        items: this.dataList,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        iszyld:this.iszyld,
        statusId:24
      };
      if (!this.dataList[0].itemName) {
        Toast({
          message: "请物品名称"
        });
        return;
      }
      axios({
        url: process.env.VUE_APP_SSO_URL+"apppurchasedOfficeliu",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "流转成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    jieanSubmit(){
      let params = {
        processId : this.processId,
        userId : this.userId,			//流程申请人
        items: this.dataList,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        iszyld:this.iszyld,
        statusId:27
      };
      if (!this.dataList[0].itemName) {
        Toast({
          message: "请物品名称"
        });
        return;
      }
      axios({
        url: process.env.VUE_APP_SSO_URL+"apppurchasedOfficejie",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "结案成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    handelSubmit() {
      if (!this.dataList[0].itemName) {
        Toast({
          message: "请物品名称"
        });
        return;
      }
      let params = {
        iszyld:this.iszyld,
        processId : this.processId,
        userId : this.userId,			//流程申请人
        items: this.dataList,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        statusId:23
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"apppurchased",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "提交成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    caogaoSubmit() {
      if (!this.dataList[0].itemName) {
        Toast({
          message: "请物品名称"
        });
        return;
      }
      let params = {
        iszyld:this.iszyld,
        processId : this.processId,
        userId : this.userId,			//流程申请人
        items: this.dataList,
        nameuser : this.nameuser,
        processDescribe : this.processDescribe,	//用车事由
        proFileid:this.fileIds.join(','),
        statusId:22
      };
      axios({
        url: process.env.VUE_APP_SSO_URL+"apppurchased",
        method: "POST",
        data:params
      }).then(res => {
        console.log(res)
        if(res.data=='sucess'){
          Toast({
            message: "保存草稿成功",
            position: 'middle',
            iconClass: "icon icon-success"
          });
          this.goBack();
        }
        else {
          Toast({
            message: res.data,
            position: 'middle',
            iconClass: "icon icon-success"
          });
        }
      })
    },
    goBack() {
      this.$router.push(this.route==undefined?"/procedure/addProcedure":this.route);
    }
  },
};
</script>

<style lang="less">
@color: #ffffff;
@border-rd: 10px;

html {
  overflow: hidden;
  height: 100%;
  background: #f5f5f5;
}
.dynamic-table {
  margin-top: 1rem;
}

.table-row {
  display: flex;
  align-items: center;
  margin-bottom: 0.5rem;
}

.table-row .van-field {
  flex: 1;
  margin-right: 0.5rem;
}

.table-row .van-button {
  /* 调整删除按钮的样式，如果需要的话 */
}

/* 可以根据需要为不同字段添加特定的样式 */
.table-row .van-field:nth-child(1) {
  flex: 2; /* 物品名称字段可以更宽一些 */
}

.table-row .van-field:nth-child(2) {
  flex: 1.5; /* 规格型号字段宽度适中 */
}

.table-row .van-field:nth-child(3) {
  flex: 1; /* 数量字段可以窄一些 */
}
body {
  display: block;
  margin: 0rem !important;
}
.app {
  /* padding: 0.5rem; */
  background-color: rgb(240, 240, 240, 0.75);
}
.van-field__control {
  line-height:  2rem;
  font-size: 1.5rem !important;
  margin-top: 10px;
}
.delete-btn {
  color: red;
  cursor: pointer;
  margin-left: 50px;
}
.van-field__label {
  span{
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb
  }
  width: 8.2rem;
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.van-field__value {
  line-height:  2rem;
  font-size: 2rem !important;
  margin-top: 10px;
}
.userinfoAdd {
  .idea {
    height: 2.466667rem;
    line-height: 2.466667rem;
    font-size: 1rem;
    background: #efefef;
    color: #646566;
    text-align: center;
    margin-bottom: 0.4rem;
    margin: 0.5rem 0;
  }
  .mint-cell-label {
    font-size: 1.2rem !important;
    font-weight: 700;
    color: #6d9eeb !important;
    margin-left: -20px;
  }
  .owntext {
    padding: 0 !important;

    .van-field__control {
      height: 600px !important;
    }
    .van-field__word-limit {
      height: 75px;
      line-height: 75px;
      margin-bottom: 30px;
    }
  }
  .ownupload {
    margin: 0.5rem 0;
    .van-uploader__preview {
      margin: 10px 10px 10px 0;
      .van-image__error-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-image,
    .van-uploader__upload {
      width: 200px;
      height: 200px;
      border: 1px dashed #ccc;
      .van-uploader__upload-icon {
        font-size: 90px;
      }
    }
    .van-uploader__preview-delete {
      width: 50px;
      height: 50px;
      .van-uploader__preview-delete-icon {
        font-size: 55px;
      }
    }
  }
  .van-cell {
    align-items: center;
    .van-field__label {
      width: 400px;
      font-size: 60px;
      height: 100px;
      line-height: 100px;
      color: #382c2c;
    }
  }
  .van-field__body {
    input {
      border: none !important;
      color: black;
    }
    textarea {
      padding-left: 30px;
    }
  }
  .addsub{
    width: 30%;
    height: 120px;
    line-height: 120px;
    font-size: 100px;
    background: #5ff56e;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
  .sub {
    width: 50%;
    height: 200px;
    line-height: 200px;
    font-size: 75px;
    background: #5f9cf5;
    border-radius: 50px 50px 50px 50px;
    text-align: center;
    cursor: pointer;
    color: #e5f4f9;
    margin-top: 100px;
  }
}
.system-pageAddD {
  width: 100%;
  height: 100vh;
  background-color: #fff;
  font-family: "PingFangSC-Regular";
}

/** 加载中 */
.back-loading {
  width: 100%;
  height: 100%;
  background-color: white;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 999;
  text-align: center;
  line-height: 25rem;
  font-size: 1rem;
  color: grey;
}
.van-field__error-message {
  line-height: 1.3rem;
}
.custom-list {
  overflow-y: auto; /* 如果内容超出容器高度，则启用垂直滚动 */
  padding: 0;
  margin: 0;
  list-style: none; /* 移除默认的列表样式 */
  background-color: #fff; /* 背景颜色 */
  border-radius: 4px; /* 圆角 */
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1); /* 阴影效果 */
}
.list-item {
  line-height: 1.4rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 16px;
  border-bottom: 1px solid #ebeef5; /* 分隔线 */
}
.list-item input:disabled {
  opacity: 0.5; /* 置灰效果 */
  cursor: not-allowed; /* 禁止点击的鼠标样式 */
}
.item-content{
  width: 21rem;
}
/* 为title定义样式，这通常是列表项中的主标题 */
.title {
  font-size: 1.213333rem; /* 字体大小 */
  font-weight: bold; /* 加粗 */
  color: #333; /* 字体颜色 */
  margin-bottom: 8px; /* 与副标题之间的间距 */
}

/* 为subtitle定义样式，这通常是列表项中的副标题或额外信息 */
.subtitle {
  font-size: 1.213333rem; /* 字体大小 */
  color: #666; /* 字体颜色 */
}

/* 额外的样式，例如复选框 */
.list-item input[type="checkbox"] {
  margin-top: 0; /* 移除复选框上方的默认间距 */
  margin-right: 16px; /* 复选框与文本之间的间距 */
}
.van-picker__toolbar {
  height: 1.586667rem;
}
.van-picker__cancel, .van-picker__confirm {
  padding: 0 0.213333rem;
  font-size: 1.186667rem;
}
.van-picker__title {
  font-size: 1.213333rem;
  line-height: 1.266667rem;
}
.van-picker-column__item {
  line-height: 1rem
}
.van-picker-column {
  font-size: .8rem;
}
.van-cell {
  font-size: 0.9rem;
  line-height: 1.32rem;
}
.van-field__control:read-only {
  font-size: .8rem;
}
</style>
